<!--
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author:
 * @Date: 2020-07-21 16:54:52
 * @LastEditTime: 2020-08-24 10:15:36
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/views/Header/header.vue
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
-->

<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="1"
              class="header_height">
        <i class="el-icon-s-fold i_icon"
           @click="handleIsCollapse(!isCollapse)"></i>
      </el-col>
      <el-col :span="9">
        <el-breadcrumb class="app-breadcrumb"
                       separator="/">
          <!-- <transition-group name="breadcrumb"> -->
          <el-breadcrumb-item v-for="(item,index) in levelList"
                              :key="item.path">
            <span v-if="index==levelList.length-1"
                  class="no-redirect">{{ item.name }}</span>
            <a v-else
               @click.prevent="handleLink(item)">{{ item.name }}</a>
          </el-breadcrumb-item>
          <!-- </transition-group> -->
        </el-breadcrumb>
      </el-col>
      <el-col :span="2"
              :offset="12">
        <el-dropdown class="avatar-container right-menu-item hover-effect"
                     trigger="click">
          <div class="avatar-wrapper"
               type="text">
            <img :src="userPhoto"
                 class="user-avatar">
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>
              <el-container>
                <el-aside style="width:36px;">
                  <img :src="userPhoto"
                       style="border-radius: 50%;" />
                </el-aside>
                <el-container style="display:flex;flex-direction: column;color:#606266;line-height:1.5;">
                  <el-col>{{userName}} </el-col>
                  <el-col style="font-size:12px;">{{userRole}}</el-col>
                </el-container>
              </el-container>
            </el-dropdown-item>
            <el-menu mode="horizontal">
              <el-submenu index="2">
                <template slot="title">{{$t('header.lang')}}</template>
                <el-menu-item :index="'2-'+index+1"
                              v-for="(item,index) in languages"
                              :key="index"
                              @click="changeLanguage(index)">{{item.name}}</el-menu-item>
              </el-submenu>
            </el-menu>
            <el-dropdown-item divided
                              @click.native="logout">
              <span style="display:block;text-align:center;">{{$t('header.logout')}}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'
import { SET_IS_COLLAPSE } from '../../store/mutation-types'
import { setStore, getStore, clearStore } from '@/utils/store'
export default {
  inject: ['reload'],
  data () {
    return {
      languages: [
        {
          name: '中文',
          value: 'zh-CN'
        },
        {
          name: 'Engilsh',
          value: 'en'
        }
      ],
      levelList: [],
      user_defualt_img: require("@/imgs/1.png"), // 默认头像
      userName: '', // 用户名称
      userPhoto: '', // 用户头像
      userRole: '' // 用户角色
    }
  },
  mounted () {
    this.getUser();
    this.getLangsList();
    this.getBreadcrumb();
    this.levelList = [];
    let a = {
      name: getStore({ name: 'route_parent', type: true }),
      path: ''
    };
    this.levelList.push(a);
    let b;
    if (getStore({ name: 'route_son', type: true }) != '' && getStore({ name: 'route_son', type: true }) != undefined) {
      b = {
        name: getStore({ name: 'route_son', type: true }),
        path: getStore({ name: 'route', type: true })
      };
      this.levelList.push(b);
    }
    // console.log(getStore({ name: 'route_son', type: true }))
    this.levelList = this.levelList.filter(item => item.name !== false);
    // console.error(this.levelList)
  },
  watch: {
    $route (route) {
      // console.log("route", route)
      // if you go to the redirect page, do not update the breadcrumbs
      // if (route.path.startsWith('/redirect/')) {
      //   return
      // }
      this.levelList = [];
      let a = {
        name: getStore({ name: 'route_parent', type: true }),
        path: ''
      };
      this.levelList.push(a);
      let b;
      console.log(getStore({ name: 'route_son', type: true }))
      if (getStore({ name: 'route_son', type: true }) != '' && getStore({ name: 'route_son', type: true }) != undefined) {
        b = {
          name: getStore({ name: 'route_son', type: true }),
          path: getStore({ name: 'route', type: true })
        };
        this.levelList.push(b);
      }
      this.levelList = this.levelList.filter(item => item.name !== false);
      // console.error(this.levelList)
      this.getBreadcrumb()
    }
  },
  computed: {
    ...mapState({
      isCollapse: state => state.menu.isCollapse
    })
  },
  methods: {
    ...mapActions(['Todologout','TodoConfig', 'getUserInfo', 'getLanguagesList', 'changeL']),
    ...mapMutations([
      SET_IS_COLLAPSE
    ]),
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => item.name)
      console.log("matched", matched)
      // this.levelList = matched.filter(item => item.name !== false);
      // console.log("this.levelList", this.levelList)
    },
    isDashboard (route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Home'.toLocaleLowerCase()
    },
    /**
     * 处理是否展开左侧栏
     * @param isCollapse
     */
    handleIsCollapse (isCollapse) {
      this.SET_IS_COLLAPSE(isCollapse)
    },
    /**
     * 获取用户信息
     */
    getUser () {
      this.getUserInfo().then((res) => {
        this.userName = res.user.displayName;
        if (res.user.photo == null || res.user.photo == 'null') {
          this.userPhoto = this.user_defualt_img
        } else {
          this.userPhoto = res.user.photo;
        }
        for (let i = 0; i < res.user.roles.length; i++) {
          if (i == res.user.roles.length - 1) {
            this.userRole += res.user.roles[i].name
          } else {
            this.userRole += res.user.roles[i].name + ' , '
          }
        }
      })
    },
    /**
     * 退出登录-
     */
    logout () {
      this.$confirm('您确认要退出登录吗, 是否继续?', '提示', {
        confirmButtonText: '确认退出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       this.TodoConfig().then((res1) => {
          let oidctoken = getStore({ name: "OIDCToken", type: true });
          let url1=res1.base_url+"oauth2"+res1.realm_path+"/connect/endSession?id_token_hint="+oidctoken+"&post_logout_redirect_uri="+res1.logout_redirect_uri;
          console.log(url1);
          this.Todologout().then((res) => {
              clearStore({ type: true })
              window.location.href =url1;
              //this.$router.push({ path: '/login' })
              this.$message({
                type: 'success',
                message: '退出成功!'
              })
              
            })
    })
       
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消退出'
        })
      })
    },
    /*
     *获取支持语言列表
     */
    getLangsList () {
      this.getLanguagesList().then((res) => {
        console.log("支持语言列表", res)
        this.languages = res.language
      }).catch((e) => {
        console.log('支持语言列表', e)
      })
    },
    // 切换语言
    changeLanguage (index) {
      console.log(this.languages[index].value)
      this.$i18n.locale = this.languages[index].value;
      this.changeL({ 'name': this.languages[index].name, 'value': this.languages[index].value })
      setStore({name: 'lang', content: { 'name': this.languages[index].name, 'value': this.languages[index].value }, type: true})
      this.reload();
    }
  }
}
</script>
<style scoped lang="less">
.header_height {
  height: 56px;
  line-height: 56px;
}
.i_icon {
  font-size: 20px;
  cursor: pointer;
}
.avatar-wrapper {
  margin-top: 5px;
  position: relative;
}
.user-avatar {
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown {
  height: 45px;
}
.el-dropdown-menu__item--divided {
  border-top: none;
  margin-top: 0;
}
.el-aside {
  background: #fff;
  margin: auto 0;
}
.el-header {
  display: inline-block;
}
.el-menu--horizontal > .el-submenu {
  clear: both;
  text-align: center;
  width: 100%;
}
/deep/.el-submenu__title {
  border: 0px solid #000;
  height: auto !important;
  line-height: 3 !important;
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Header/header.vue